let formsDrawerOpen = false;

function updateFormsEmbed(open = formsDrawerOpen) {
  formsDrawerOpen = Boolean(open);
  let updated = false;

  document.querySelectorAll('shopify-forms-embed').forEach((formsEmbed) => {
    const appEmbed = formsEmbed.shadowRoot?.querySelector('#app-embed');
    if (!appEmbed) return;

    appEmbed.style.zIndex = '109';
    appEmbed.style.visibility = formsDrawerOpen ? 'hidden' : '';
    appEmbed.style.pointerEvents = formsDrawerOpen ? 'none' : '';
    updated = true;
  });

  return updated;
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        document.body.addEventListener('right-drawer-is-open', () => {
          updateFormsEmbed(true);
        });
        document.body.addEventListener('right-drawer-is-closed', () => {
          updateFormsEmbed(false);
        });

        const formsObserver = new MutationObserver(() => {
          if (updateFormsEmbed()) formsObserver.disconnect();
        });
        formsObserver.observe(document.body, { childList: true, subtree: true });

        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'cascade:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
